import React from "react"
import {Table as BootstrapTable} from "react-bootstrap"
import PropTypes from "prop-types"

import Tr from "./Tr"
import Th from "./Th"


const Table = ({children, headings, ...props}) => {
  return (
    <BootstrapTable {...props}>
      {headings && headings.length > 0 && (
        <thead>
          <Tr>
            {headings.map(({title, ...headingProps}) => (
              <Th key={title} {...headingProps}>
                {title}
              </Th>
            ))}
          </Tr>
        </thead>
      )}
      <tbody>
        {children}
      </tbody>
    </BootstrapTable>
  )
}

Table.propTypes = {
  children: PropTypes.node,
  headings: PropTypes.array
}

Table.defaultProps = {
  children: null,
  headings: []
}

export default Table
